// extracted by mini-css-extract-plugin
module.exports = {"category":"Grouping_category__3TU6M","itemPart":"Grouping_itemPart__R3SFK","underText":"Grouping_underText__3Av2r","picHolder":"Grouping_picHolder__1EILU"};